<template>
  <v-card class="mx-auto" max-width="400">
    <Carousel height="200" :images="images" />
    <v-card-title>{{ bien.name }} / {{ bien.localisation }}</v-card-title>
    <v-card-subtitle class="pb-0">{{ bien.id }}</v-card-subtitle>

    <v-card-text class="text--primary">
      <div>{{ bien.search_description }}</div>
    </v-card-text>

    <v-card-actions>
      <v-btn color="blue" text>
        go
      </v-btn>

      <v-btn color="red" text @click="handleDelete">
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Carousel from "../Carousel";
import { getImages } from "@/services/image";
import { deleteBien } from "@/services/biens";

export default {
  components: {
    Carousel
  },
  props: ["bien", "fetch"],
  data: () => ({
    images: []
  }),

  methods: {
    handleDelete() {
      deleteBien(this.bien.id, () => {
        this.fetch();
      });
    }
  },

  beforeMount() {
    getImages(this.bien.id, images => (this.images = images));
  }
};
</script>
